import * as React from "react";
import type { SVGProps } from "react";
const SvgExpandMoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#expand_more-icon_svg__a)">
      <path
        fill="currentColor"
        d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
      />
    </g>
    <defs>
      <clipPath id="expand_more-icon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgExpandMoreIcon;
